module.exports = __webpack_public_path__ + "img/schalke-04.a1894313.png";